import React from "react";
import "./RefundNoPurchases.sass";

function RefundNoPurchases() {
  return (
    <>
      <div className="no-purchases__wrapper">
        <h3 className="no-purchases__title">No Purchases</h3>
        <p className="no-purchases__text">
          Once you make a purchase, you will be able <br />
          to apply for a refund
        </p>
      </div>
    </>
  );
}

export default RefundNoPurchases;
